<template>
  <top-nav>
    <li v-if="$can.view($store.getters.getAuthUser, 'list-users')">
      <router-link :to="{ name: 'users.index'}">
        System Users
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'list-customers')">
      <router-link :to="{ name: 'users.customers'}">
        Customers
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'list-relationship-managers')">
      <router-link :to="{ name: 'rms'}">
        RMs
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'restore-user')">
      <router-link :to="{ name: 'users.deleted'}">
        Deleted Users
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'view-Banlists')">
      <router-link :to="{ name: 'users.banned'}">
        Banned Users
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'list-roles')">
      <router-link :to="{ name: 'users.roles'}">
        Roles
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'attach-permissions')">
      <router-link :to="{ name: 'users.permissions'}">
        Permissions
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'create-users')">
      <router-link :to="{ name: 'users.create'}">
        Create User
      </router-link>
    </li>
  </top-nav>
</template>

<script>
    import TopNav from "@/components/TopNav.vue";

    export default {
        components: {
            TopNav
        }
    }
</script>
